module.exports = __webpack_public_path__ + "static/ec-efficacy-desktop-473f8ea87d1164f5cc957f247581e8d3.png";